import React, { useState } from 'react';
import './Header.css';
import AuthManager from './AuthManager';

const Header = ({ currentPage, onNavigate }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Función para cerrar el menú
  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  // Función para manejar navegación y cerrar menú
  const handleNavigation = (page) => {
    onNavigate(page);
    closeMenu();
  };

  return (
    <header className="header">
      <div className="container">
        <div className="nav-brand">
          <div className="logo" onClick={() => handleNavigation('home')} style={{ cursor: 'pointer' }}>
            <img src={require('../asset/images/logomenu.png')} alt="ExpertMind Logo" className="logo-img" style={{ height: '32px' }} />
          </div>
        </div>
        
        <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
          {currentPage === 'home' ? (
            <>
              <a href="#inicio" className="nav-link" onClick={closeMenu}>Inicio</a>
              <a href="#problemas" className="nav-link" onClick={closeMenu}>Problemas</a>
              <a href="#solucion" className="nav-link" onClick={closeMenu}>Solución</a>
              <a href="#diferenciadores" className="nav-link" onClick={closeMenu}>Diferenciadores</a>
              <a href="#contacto" className="nav-link" onClick={closeMenu}>Contacto</a>
              <button 
                className="nav-link nav-button nav-blog-btn" 
                onClick={() => handleNavigation('blog')}
              >
                📖 Blog
              </button>
            </>
          ) : (
            <>
              <button 
                className="nav-link nav-button" 
                onClick={() => handleNavigation('home')}
              >
                ← Inicio
              </button>
              <span className="nav-link active">Blog</span>
            </>
          )}
        </nav>
        
        <div className="nav-actions">
          <AuthManager className="header-auth" onMenuAction={closeMenu} />
          <button 
            className="menu-toggle"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label={isMenuOpen ? 'Cerrar menú' : 'Abrir menú'}
            aria-expanded={isMenuOpen}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
